<script>
    import Main from './layout/Main.svelte';
    import QuotationViewer from "../com/business/QuotationViewer.svelte";
    import Chat from "../com/Chat/Chat.svelte";

    import Shepherd from 'shepherd.js';
    import 'shepherd.js/dist/css/shepherd.css';
    import {onMount} from "svelte";
    import { t } from "../i18n";

    export let params = {};

    $: chatMarginTop = 0;
    $: quotationTitle = '-';
    $: quotationRow = null;

    let hideChat = false;

    let qid; $: qid = params.id;

    var divToggleChat = null;

    // -----------------------------------------------------------
    var setChatMarginTop = function(val){
        if(chatMarginTop!=val) chatMarginTop = val;
    };
    var updateChatMarginTop = function(){
        if(window.innerWidth < 1200){
            if(divToggleChat && divToggleChat.style) divToggleChat.style.display = 'none';
            return setChatMarginTop(0);
        }

        if(divToggleChat && divToggleChat.style) divToggleChat.style.display = 'block';

        let scrollableSpace = document.documentElement.scrollHeight - window.innerHeight;
        if(scrollableSpace < 1 )return setChatMarginTop(0);


        return setChatMarginTop(document.documentElement.scrollTop);

        //chatMarginTop += 10;
    };

    setInterval(function(){
        updateChatMarginTop();
    }, 100);



    var startTour = function(){
        var tour = new Shepherd.Tour({
            useModalOverlay: true,
            defaultStepOptions: {
                classes: 'tippy-popper shadow-md bg-purple-dark',
                scrollTo: {behavior: 'smooth', block: 'center'},
                cancelIcon: {
                    enabled: true,
                }
            }
        });
        let buttons = [
            {text: $t('common.skip'), action: tour.cancel},
            {text: $t('common.next'), action: tour.next}
        ];
        tour.addStep({
            id: 'step-1',
            text: $t('quotation.tour.step1'),
            attachTo: {element: '#itinerary-tab', on: 'bottom'},
            buttons
        });
        tour.addStep({
            id: 'step-2',
            text: $t('quotation.tour.step2'),
            attachTo: {element: 'input.widget-chat-message', on: 'top'},
            buttons
        });
        buttons = [{text: $t('common.end'), action: tour.next}];
        if(window.innerWidth >= 1200) {
            tour.addStep({
                id: 'step-3i',
                text: $t('quotation.tour.step3'),
                attachTo: {element: '#hide-show-chat-div a i', on: 'bottom-end'},
                buttons
            });
        }
        tour.start();
    };


    let onQuotationFetched = function(data){
        let row = (data && data.detail)||{};

        quotationRow = row;
        quotationTitle = row.refid + ' ' + row.refid_remote;
        if(row.refid) document.title = quotationTitle;

        setTimeout(function(){
            startTour();
        }, 1000); // wait 1s for DOM to render
    };



</script>


<style>
    .content-wrapper.hide-chat div.col-quot{max-width: initial; flex: 1 1;}
    .content-wrapper.hide-chat div.col-chat{display:none;}
</style>

<Main title={quotationRow && quotationRow.refid ? quotationTitle : $t('page.quotation')}>
    <div class="app-content content">
        <div class="content-overlay"></div>
        <div class="content-wrapper {hideChat ? 'hide-chat':''}">


                <div bind:this={divToggleChat} id="hide-show-chat-div" style="text-align:right; margin:8px; padding:0 16px; cursor:pointer;" >
                    <a on:click={()=> hideChat = !hideChat}>
                        {#if hideChat}
                            <i class="bx bx-chat"></i> <span class="menu-title">{$t('quotation.show_chat')}</span>
                        {:else}
                            <i class="bx bx-chevrons-right"></i> <span class="menu-title">{$t('quotation.hide_chat')}</span>
                        {/if}
                    </a>
                </div>

            <div class="container-fluid">
                <div class="row">
                    <div class="col-xl-7 col-quot"><QuotationViewer on:quotationFetched={onQuotationFetched} {qid} ></QuotationViewer></div>
                    <div class="col-xl-5 col-chat">
                        <div style="margin-top:{chatMarginTop}px;">
                            <Chat path="/Q{qid}" title={quotationTitle}></Chat>
                        </div>
                    </div>
                </div>
            </div>

            {#if quotationRow}
                <div style="text-align:center; position: fixed; bottom: 16px; left: 50%; transform: translateX(-50%); z-index: 9999; min-width: 200px; background: white; max-width: 80%; border: 1px solid #80808026; padding: 9px 14px; border-radius: 8px; box-shadow: -8px 12px 18px 0 rgba(25, 42, 70, 0.13); border: 0px solid #dfe3e7; border-radius: 0.267rem;">
                    {$t('quotation.operating_on')} <b>{$t('quotation.ref')}</b> : {quotationRow.refid} | <b>{$t('quotation.your_ref')}</b> : {quotationRow.refid_remote}
                </div>
            {/if}

        </div>
</Main>
